import React, { PureComponent } from 'react';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';

import translates from './notification-favorite-i18n.json';

const bemClassesMessage = new Bem('favoritesMessage');

@I18nHoc(translates)
export default class NotificationFavorite extends PureComponent {
  render() {
    const { i18n } = this;

    return (
      <div {...bemClassesMessage()}>
        <div {...bemClassesMessage('header')}>
          <span {...bemClassesMessage('text')} children={i18n('favoritesAdded')} />
        </div>
        <div {...bemClassesMessage('content')}>
          <p {...bemClassesMessage('text')} children={i18n('favoritesMassageAfterAdded')} />
        </div>
      </div>
    );
  }
}
